// Display rule for a container's card count. All counts are total copies
// (sums of `quantity`), not distinct entries. Decks with a sideboard show the
// main/sideboard split because 60/15 validation depends on those totals.
export function formatContainerCount(collection) {
  const sideboard = collection.sideboard_card_count || 0;
  if (collection.type === 'DECK' && sideboard > 0) {
    return `${collection.main_card_count || 0} + ${sideboard} sb`;
  }
  const n = collection.card_count || 0;
  return `${n} ${n === 1 ? 'card' : 'cards'}`;
}
